import React from 'react'

import Modal from '../../components/Modal/Modal'
import { Route, Routes } from 'react-router-dom'

import Tag from './AdTag/CreateTag'
import AddCustomersPicker from './AddCustomersPicker'
import ServiceCustomers from './Routes/ServiceCustomers'
import SoldCustomers from './Routes/SoldCustomers'
import LeadsCustomers from './Routes/LeadsCustomers'
import UnspecifiedCustomers from './Routes/UnspecifiedCustomers'
import HashedCustomers from './Routes/HashedCustomers'
import OptOutcustomers from './Routes/OptOutCustomers'

const AddCustomersForm = (): JSX.Element => {
  return (
    <Modal modalRoute={true} isOpen={true} key={'AddCustomersSources'}>
      <Routes>
        <Route path={'/'} element={<AddCustomersPicker />} />
        <Route path={'sales'} element={<SoldCustomers />} />
        <Route path={'leads'} element={<LeadsCustomers />} />
        <Route path={'service'} element={<ServiceCustomers />} />
        <Route path={'other'} element={<UnspecifiedCustomers />} />
        <Route path={'hashed-customers'} element={<HashedCustomers />} />
        <Route path={'opt-out-customers'} element={<OptOutcustomers />} />
        <Route path={'tag'} element={<Tag />} />
      </Routes>
    </Modal>
  )
}

export default AddCustomersForm
